import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityModuleTag, SecurityRight } from '../security.module';

export enum InboundEmailSecurityRight {
    CanAccess = 5700,
    CanManage = 5701
}

export class InboundEmailSecurityModule extends BaseSecurityModule<InboundEmailSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.InboundEmail,
            [
                { _id: InboundEmailSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: InboundEmailSecurityRight.CanManage, name: 'Manage', basic: true },
            ] as SecurityRight<InboundEmailSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;
        this.tags = [SecurityModuleTag.Beta];

    }

}
